import {Navigation, Scrollbar, A11y, Autoplay} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';

import "./slider.css";
import {useEffect} from "react";

import {useLocation, useNavigate} from "react-router-dom";
import {useForceUpdate} from "../../../services/misc.functions";
import {homeSliderSubject, homeSlides, path} from "../../../store/misc.store";
import {ApiService} from "../../../lib/http.service";
import {env} from "../../../constants/global.vars";
import {isMobile} from "react-device-detect";

export function Slider() {
    const forceUpdate = useForceUpdate();
    const {pathname} = useLocation();
    const navigate = useNavigate();

    console.log(isMobile)

    useEffect(() => {
        let homeSliderSubject_subscriber = homeSliderSubject.subscribe(() => {
            forceUpdate();
        })
        return () => {
            homeSliderSubject_subscriber.unsubscribe();
        }
    })

    useEffect(() => {
        if (homeSlides.length === 0) {
            let api = new ApiService();
            api.start('get', env.api + '/misc/api/list-slide/', null, false)
                .then((res: any) => {
                    homeSlides.splice(0, homeSlides.length);
                    homeSlides.push(...res.data);
                    forceUpdate();
                })
        }
    }, [])

    if (homeSlides.length === 0) {
        return <div className="slider-wrapper"></div>;
    }

    const slides = homeSlides.length > 1
        ? Array.from({length: Math.ceil(6 / homeSlides.length)}, () => homeSlides).flat()
        : homeSlides;

    return (
        <div className="slider-wrapper">
            <Swiper
                modules={[Navigation, Scrollbar, A11y, Autoplay]}
                loop={true}
                loopAdditionalSlides={2}
                loopPreventsSliding={false}
                centeredSlides={true}
                observer={true}
                observeParents={true}
                spaceBetween={-32}
                autoplay={{delay: 5000}}
                slidesPerView={"auto"}
                navigation={isMobile ? false : true}
                onActiveIndexChange={(el: any) => {
                    const index = el.realIndex % homeSlides.length;
                    try {
                        // @ts-ignore
                        dataLayer.push({
                            event: "view_promotion",
                            ecommerce: {
                                creative_name: homeSlides[index].title, // kreatif ismi gönderilir.
                                creative_slot: index + 1, // kreatif sırası.
                                promotion_name: homeSlides[index].title, // promosyon ismi
                                promotion_id: homeSlides[index].id // promosyon id’si (VİRGÜL YOK!)
                            }
                        });
                    } catch (e) {}
                }}
            >

                {slides.map((slide: any, key: number) => {
                    return (<SwiperSlide key={`slider-${key}`}>
                        <div className="slide" onClick={() => {
                            if (slide.web_url) {
                                navigate(`${slide.web_url}`);
                            }
                            try {
                                // @ts-ignore
                                dataLayer.push({
                                    event: "view_promotion",
                                    ecommerce: {
                                        creative_name: slide.title, // kreatif ismi gönderilir.
                                        creative_slot: key % homeSlides.length + 1, // kreatif sırası.
                                        promotion_name: slide.title, // promosyon ismi
                                        promotion_id: slide.id // promosyon id’si (VİRGÜL YOK!)
                                    }
                                });
                            } catch (e) {

                            }
                        }}>
                            <img src={env.media + (isMobile ? slide.photo_mobile : slide.photo_web)} alt={slide.title}/>
                        </div>
                    </SwiperSlide>)
                })}

            </Swiper>

        </div>
    );
};
